import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { BASE_URL } from "../../config";
import { getAuthHeaders } from "../../services/useAuth";
import Loader from "../../dist/Loader";
import { FaSearch } from "react-icons/fa";
import logo from "../../images/logo1.jpg";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CustomButton from "../../pages/CustomButton";
import EmployeeMapTracker from "../../pages/EmployeeMapTracker";
import CutomButton from "../../pages/CustomButton";
import { toast } from "react-toastify";
function DynamicExpenseTable({ data = {}, onDateClick }) {
  const header = [
    "Date",
    "Leave / Holiday",
    "Route",
    "Type",
    "Dist",
    "TA",
    "DA(HQ)",
    "DA(Ex)",
    "DA(Out)",
    "Hotel",
    "Other",
    "Emp Rem",
    "Mgr Rem",
    "Aprv Date",
    "Total",
    "Auto Total (DA+TA)",
  ];

  const val = (v) => (v === undefined || v === null || v === "" ? "" : v);
  const numVal = (v) =>
    v === undefined || v === null || v === ""
      ? "0.00"
      : parseFloat(v).toFixed(2);

  const formatDate = (d) => {
    if (!d && d !== 0) return "";
    try {
      const parsed = new Date(d);
      if (!isNaN(parsed)) {
        return parsed.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
      }
      const parts = String(d)
        .split(/[-/]/)
        .map((p) => p.trim());
      if (parts.length === 3) {
        let dt;
        if (parts[0].length === 4)
          dt = new Date(`${parts[0]}-${parts[1]}-${parts[2]}`);
        else dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        if (!isNaN(dt)) {
          return dt.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
          });
        }
      }
    } catch (e) {
      // ignore
    }
    return String(d);
  };

  const { header: employeeHeader, rows: records = [] } = data;

  // Helper to check if row has no expense values
  const hasNoExpense = (record) => {
    const ta = parseFloat(record.ta) || 0;
    const da_hq = parseFloat(record.da_hq) || 0;
    const da_ex = parseFloat(record.da_ex) || 0;
    const da_out = parseFloat(record.da_out) || 0;
    const hotel = parseFloat(record.hotel) || 0;
    const other = parseFloat(record.other) || 0;

    return ta + da_hq + da_ex + da_out + hotel + other === 0;
  };

  return (
    <div className="p-2  border-2 border-gray-300 rounded-lg bg-white">
      {/* Employee Info Header */}
      <div className="mb-4 border border-gray-300 p-3 text-xs">
        <h2 className="text-sm font-bold text-center mb-2">
          Expense Sheet ({employeeHeader?.employee_name || "Employee"}) [ME]{" "}
          {employeeHeader?.employee || employeeHeader?.employee_id || ""}
          {employeeHeader?.division || ""} [{employeeHeader?.state || ""}] (
          {employeeHeader?.month_year ||
            employeeHeader?.financial_year ||
            "Period"}
          )
        </h2>

        <div className="grid grid-cols-2 gap-x-12 gap-y-1">
          <div className="flex">
            <span className="flex-1">Internet</span>
            <span className="font-bold text-right w-20">
              {numVal(employeeHeader?.internet)}
            </span>
          </div>
          <div className="flex">
            <span className="flex-1">Fooding</span>
            <span className="font-bold text-right w-20">
              {numVal(employeeHeader?.feeding)}
            </span>
          </div>

          <div className="flex">
            <span className="flex-1">Telephone</span>
            <span className="font-bold text-right w-20">
              {numVal(employeeHeader?.telephone)}
            </span>
          </div>
          <div className="flex">
            <span className="flex-1">VMA</span>
            <span className="font-bold text-right w-20">
              {numVal(employeeHeader?.vma)}
            </span>
          </div>

          <div className="flex">
            <span className="flex-1">Other</span>
            <span className="font-bold text-right w-20">
              {numVal(employeeHeader?.other)}
            </span>
          </div>
          <div className="flex">
            <span className="flex-1">Approved</span>
            <span className="font-bold text-right w-20">
              {employeeHeader?.approved ? "Yes" : "No"}
            </span>
          </div>

          <div className="flex">
            <span className="flex-1">Approve By</span>
            <span className="font-bold text-right w-20">
              {val(employeeHeader?.approve_by)}
            </span>
          </div>
          <div className="flex">
            <span className="flex-1">Approve Date</span>
            <span className="font-bold text-right w-20">
              {val(employeeHeader?.approve_date)}
            </span>
          </div>

          <div className="flex">
            <span className="flex-1">Remark</span>
            <span className="font-bold text-right w-20">
              {val(employeeHeader?.remark)}
            </span>
          </div>
          <div className="flex">
            <span className="flex-1">Immediate Manager Id</span>
            <span className="font-bold text-right w-40">
              {val(employeeHeader?.immediate_manager)}
            </span>
          </div>

          <div className="flex">
            <span className="flex-1">Employee ID</span>
            <span className="font-bold text-right w-20">
              {val(employeeHeader?.employee)}
            </span>
          </div>
          <div className="flex">
            <span className="flex-1">Total</span>
            <span className="font-bold text-right w-20">
              {numVal(employeeHeader?.telephone)}
            </span>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto border border-gray-300">
        <table className="expense-sheet-table min-w-full table-auto text-[11px]">
          <thead>
            <tr>
              {header.map((h) => (
                <th
                  key={h}
                  className="border border-gray-400 px-1 py-1 text-[11px] text-center bg-blue-600 text-white"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {records.length === 0
              ? Array.from({ length: 4 }).map((_, i) => (
                  <tr
                    key={"empty" + i}
                    className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    {header.map((_, j) => (
                      <td
                        key={j}
                        className="border border-gray-300 px-1 py-1"
                      ></td>
                    ))}
                  </tr>
                ))
              : records.map((r, idx) => {
                  // Dynamic key resolution with fallbacks
                  const dateRaw = r.date || r.entry_date || r.logged_at || "";
                  const date = formatDate(dateRaw);

                  const leave = val(
                    r.leave_type || r.leave_holiday || r.leave_meeting || "",
                  );
                  // route_name expected in new API; fallback to route
                  const route = val(r.route_name || r.route || "");
                  const type = val(r.type || r.expense_type || "");
                  // dist can be "distance" or "dist"
                  const dist = val(r.distance ?? r.dist ?? "");

                  const ta = numVal(r.ta);
                  const da25 = numVal(r.da_hq);
                  const da50 = numVal(r.da_ex);
                  const da100 = numVal(r.da_out);
                  const hotel = numVal(r.hotel);
                  const other = numVal(r.other);
                  const empRem = val(r.emp_remark || r.employee_remarks || "");
                  const mgrRem = val(r.manager_remarks || "");
                  const aprvDate = val(r.approve) ? "Approved" : "Pending";
                  const total = numVal(r.total);
                  // Auto total calculation (DA + TA)
                  const autoTotal = (
                    (parseFloat(r.da_hq || 0) || 0) +
                    (parseFloat(r.da_ex || 0) || 0) +
                    (parseFloat(r.da_out || 0) || 0) +
                    (parseFloat(r.ta || 0) || 0)
                  ).toFixed(2);

                  // Determine background color
                  const noExpense = hasNoExpense(r);
                  const isSunday =
                    leave && String(leave).toLowerCase().includes("sunday");

                  let bgClass = "";
                  if (noExpense) {
                    bgClass = "bg-blue-100"; // Light blue for rows with no expenses
                  } else if (isSunday) {
                    bgClass = "bg-teal-100";
                  } else {
                    bgClass = idx % 2 === 0 ? "bg-white" : "bg-gray-50";
                  }

                  return (
                    <tr
                      key={`${date}-${idx}`}
                      className={`${bgClass} text-[11px]`}
                    >
                      <td
                        className="border border-gray-300 px-1 py-1 cursor-pointer hover:bg-blue-200 transition-colors"
                        onClick={() =>
                          onDateClick &&
                          onDateClick(
                            employeeHeader?.employee_id,
                            dateRaw,
                            employeeHeader?.employee_name,
                          )
                        }
                        title="Click to view location tracker"
                      >
                        <span className="text-blue-600 underline">{date}</span>
                      </td>
                      <td className="border border-gray-300 px-1 py-1">
                        {leave}
                      </td>
                      <td className="border border-gray-300 px-1 py-1">
                        {route}
                      </td>
                      <td className="border border-gray-300 px-1 py-1">
                        {type}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 text-right">
                        {dist}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 text-right">
                        {ta}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 text-right">
                        {da25}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 text-right">
                        {da50}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 text-right">
                        {da100}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 text-right">
                        {hotel}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 text-right">
                        {other}
                      </td>
                      <td className="border border-gray-300 px-1 py-1">
                        {empRem}
                      </td>
                      <td className="border border-gray-300 px-1 py-1">
                        {mgrRem}
                      </td>
                      <td className="border border-gray-300 px-1 py-1">
                        {aprvDate}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 text-right">
                        {total}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 text-right">
                        {autoTotal}
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </div>

      {/* Footer Totals - Dynamic */}
      <div
        className="mt-4 text-[11px] border-t border-blue-700 pt-2 p-2"
        style={{ backgroundColor: "rgb(59 130 246 / 0.12)" }}
      >
        <div className="grid grid-cols-4 gap-2">
          <div>
            TA:{" "}
            {numVal(
              records.reduce((sum, r) => sum + (parseFloat(r.ta) || 0), 0),
            )}
          </div>
          <div>
            DA:{" "}
            {numVal(
              records.reduce(
                (sum, r) =>
                  sum +
                  ((parseFloat(r.da_hq) || 0) +
                    (parseFloat(r.da_ex) || 0) +
                    (parseFloat(r.da_out) || 0)),
                0,
              ),
            )}
          </div>
          <div>
            Other:{" "}
            {numVal(
              records.reduce((sum, r) => sum + (parseFloat(r.other) || 0), 0),
            )}
          </div>
          <div>
            Total:{" "}
            {numVal(
              records.reduce((sum, r) => sum + (parseFloat(r.total) || 0), 0),
            )}
          </div>
        </div>
        <div className="mt-1">
          Daily Average:{" "}
          {numVal(
            records.reduce((sum, r) => sum + (parseFloat(r.total) || 0), 0) /
              (records.length || 1),
          )}{" "}
          | Records Count: {records.length}
        </div>
      </div>
    </div>
  );
}

const ExpensePrint = () => {
  const [states, setStates] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [substates, setSubstates] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubState, setSelectedSubState] = useState("");

  // Separate month and year dropdowns
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = ["2024", "2025", "2026"];

  const [employeesData, setEmployeesData] = useState([]); // Array of employee data
  const [showContainers, setShowContainers] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Search state
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const inputRef = useRef(null);

  // Map Modal State
  const [mapModal, setMapModal] = useState({
    isOpen: false,
    employeeData: null,
  });

  // Initialize current month and year
  useEffect(() => {
    const now = new Date();
    setSelectedMonth(months[now.getMonth()]);
    setSelectedYear(now.getFullYear().toString());
  }, []);

  // Fetch States
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/states`, {
          headers: getAuthHeaders(),
        });
        setStates(response.data || []);
      } catch (err) {
        console.error("Error fetching states:", err);
        setError("Failed to load states");
      }
    };
    fetchStates();
  }, []);

  // Fetch SubStates
  const fetchSubStates = async (stateId) => {
    if (!stateId) return;

    try {
      const res = await axios.get(
        `${BASE_URL}/api/substates?state_id=${stateId}`,
        { headers: getAuthHeaders() },
      );
      const list = res.data || [];
      setSubstates(list);
      setSelectedSubState("");
    } catch (err) {
      console.error("substates load failed", err);
    }
  };

  // Fetch Divisions
  const fetchDivisions = async (stateId) => {
    if (!stateId) return;

    try {
      const divisionRes = await axios.get(
        `${BASE_URL}/api/divisions?state_id=${stateId}`,
        { headers: getAuthHeaders() },
      );
      setDivisions(divisionRes.data || []);
      setSelectedDivision("");
    } catch (err) {
      console.error("Error loading divisions", err);
    }
  };

  const handleStateChange = async (stateId) => {
    setSelectedState(stateId);
    setSelectedDivision("");
    setSelectedSubState("");
    setShowContainers(false);

    if (stateId) {
      await fetchDivisions(stateId);
      await fetchSubStates(stateId);
    } else {
      setDivisions([]);
      setSubstates([]);
    }
  };

  const handleDivisionChange = (divisionId) => {
    setSelectedDivision(divisionId);
    setShowContainers(false);
  };

  const handleSubStateChange = (subId) => {
    setSelectedSubState(subId);
    setShowContainers(false);
  };

  // Map Modal Handlers
  const openMapModal = (employeeId, trackDate, employeeName) => {
    setMapModal({
      isOpen: true,
      employeeData: {
        employeeId,
        trackDate,
        employeeName,
        context: "expense-sheet",
        location: null,
      },
    });
  };

  const closeMapModal = () => {
    setMapModal({
      isOpen: false,
      employeeData: null,
    });
  };

  // Fixed API Integration with month_year parameter
  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      setEmployeesData([]);
      setShowContainers(false);

      // Build month_year parameter (e.g., "November 2025")
      const monthYear = `${selectedMonth} ${selectedYear}`;

      // Build query parameters correctly
      const params = {
        state_id: selectedState || undefined,
        month_year: monthYear,
      };

      // Only add these if they have values (not empty strings)
      if (selectedSubState) params.substate_id = selectedSubState;
      if (selectedDivision) params.division_id = selectedDivision;

      console.log("API Params:", params);

      const response = await axios.get(
        `${BASE_URL}/api/employee-expense-sheets`,
        {
          headers: getAuthHeaders(),
          params: params,
        },
      );

      console.log("API Response:", response.data);

      if (response.data) {
        // Handle both single employee response and array of employees
        if (Array.isArray(response.data)) {
          setEmployeesData(response.data);
        } else {
          setEmployeesData([response.data]);
        }
      } else {
        setEmployeesData([]);
      }

      setShowContainers(true);
    } catch (err) {
      console.error("API Error:", err);
      if (err.response && err.response.data) {
        if (Array.isArray(err.response.data.detail)) {
          setError(err.response.data.detail.map((d) => d.msg).join(", "));
        } else {
          setError(JSON.stringify(err.response.data));
        }
      } else {
        setError("Failed to fetch expense data");
      }
      setEmployeesData([]);
      setShowContainers(true);
    } finally {
      setIsLoading(false);
    }
  }, [
    selectedState,
    selectedSubState,
    selectedDivision,
    selectedMonth,
    selectedYear,
  ]);

  const handleGoClick = () => {
    if (!selectedState) {
      setError("Please select a state first");
      return;
    }
    if (!selectedMonth || !selectedYear) {
      setError("Please select both month and year");
      return;
    }
    fetchData();
  };

  // Export All Sheets to Excel
  const exportAllToExcel = () => {
    if (!employeesData || employeesData.length === 0) {
      toast("No data available for export");
      return;
    }

    const wb = XLSX.utils.book_new();

    employeesData.forEach((employee, index) => {
      const sheetName = `Emp_${employee.header?.employee || "ID"}_${index + 1}`;
      console.log("Adding sheet for:", employee.header?.employee_name);
      const worksheetData = [];

      worksheetData.push([
        "Expense Sheet",
        employee.header?.employee_name || "",
        `ID: ${employee.header?.employee || employee.header?.employee_id}`,
        `${selectedMonth} ${selectedYear}`,
      ]);

      worksheetData.push([]);
      worksheetData.push([]);

      worksheetData.push([
        "Internet",
        employee.header?.internet || "0.00",
        "Fooding",
        employee.header?.feeding || "0.00",
      ]);

      worksheetData.push([
        "Telephone",
        employee.header?.telephone || "0.00",
        "VMA",
        employee.header?.vma || "0.00",
      ]);

      worksheetData.push([
        "Other",
        employee.header?.other || "0.00",
        "Approved",
        employee.header?.approved ? "Yes" : "No",
      ]);

      worksheetData.push([
        "Approve By",
        employee.header?.approve_by || "",
        "Approve Date",
        employee.header?.approve_date || "",
      ]);

      worksheetData.push([
        "Remark",
        employee.header?.remark || "",
        "Immediate Manager",
        employee.header?.immediate_manager || "",
      ]);

      worksheetData.push([
        "Employee ID",
        employee.header?.employee || employee.header?.employee_id || "",
        "Division",
        employee.header?.division || "",
      ]);

      worksheetData.push([]);

      if (employee.rows && employee.rows.length > 0) {
        employee.rows.forEach((record) => {
          const autoTotal = (
            parseFloat(record.da_hq || 0) +
            parseFloat(record.da_ex || 0) +
            parseFloat(record.da_out || 0) +
            parseFloat(record.ta || 0)
          ).toFixed(2);

          worksheetData.push([
            record.date || "",
            record.leave_type || "",
            record.route_name || "",
            record.type || "",
            record.distance || "",
            record.ta || "0.00",
            record.da_hq || "0.00",
            record.da_ex || "0.00",
            record.da_out || "0.00",
            record.hotel || "0.00",
            record.other || "0.00",
            record.emp_remark || "",
            record.manager_remarks || "",
            record.approve ? "Approved" : "Pending",
            record.total || "0.00",
            autoTotal,
          ]);
        });
      }

      const ws = XLSX.utils.aoa_to_sheet(worksheetData);

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });
    console.log("Total Sheets:", wb.SheetNames);
    XLSX.writeFile(
      wb,
      `Employee_Expense_${selectedMonth}_${selectedYear}.xlsx`,
    );
  };

  // Print All Sheets
  const printAllSheets = () => {
    const printContent = employeesData
      .map((employee, index) => {
        const sheetElement = document.querySelectorAll(".expense-sheet-table")[
          index
        ];
        return sheetElement
          ? `
        <div class="employee-sheet">
          <h3>Employee: ${employee.header?.employee_name} (ID: ${employee.header?.employee || employee.header?.employee_id})</h3>
          <div class="employee-info">
            State: ${employee.header?.state} | Sub State: ${employee.header?.substate} | Division: ${employee.header?.division}
          </div>
          ${sheetElement.outerHTML}
        </div>
        <div style="page-break-after: always;"></div>
      `
          : "";
      })
      .join("");

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
      <html>
        <head>
          <title>All Employee Expense Sheets</title>
          <style>
            @page { size: landscape; margin: 10mm; }
            body { font-family: Arial, sans-serif; margin: 0; padding: 20px; }
            .employee-sheet { margin-bottom: 30px; }
            .employee-info { margin: 10px 0; font-size: 12px; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 10px; }
            th, td { border: 1px solid #ddd; padding: 6px 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .page-break { page-break-after: always; }
          </style>
        </head>
        <body>
          <h1>Employee Expense Sheets - ${selectedMonth} ${selectedYear}</h1>
          ${printContent}
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
                window.close();
              }, 500);
            }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="pob-fy-main-container">
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25">
          <Loader onCancel={() => setIsLoading(false)} />
        </div>
      )}
      <div
        className={`main-container ${
          isLoading ? "blur-sm pointer-events-none" : ""
        }`}
      >
        <section className="px-4 sm:px-6 lg:px-8 mt-2">
          <div className="rounded-md border border-gray-300 bg-white p-4">
            <h1 className="text-2xl sm:text-3xl font-bold text-center mb-3">
              <span className="text-blue-700">Employee Expense </span>
              <span className="text-blue-500">Sheets</span>
            </h1>

            <form className="w-full">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                {/* LEFT: col-span 5 */}
                <div className="md:col-span-5 col-span-12 space-y-3">
                  {/* State row */}
                  <div className="flex items-center">
                    <label
                      htmlFor="state"
                      className="w-24 text-right mr-4 text-sm text-gray-700"
                    >
                      State <span className="text-red-500">*</span>
                    </label>

                    <div className="flex-1">
                      <select
                        id="state"
                        className="w-full border-2 border-gray-300 rounded px-2 text-sm h-9 bg-white focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition"
                        value={selectedState}
                        onChange={(e) => handleStateChange(e.target.value)}
                        disabled={isLoading}
                      >
                        <option value="">Select State</option>
                        {states.map((state) => (
                          <option key={state.id} value={state.id}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Substate row */}
                  <div className="flex items-center">
                    <label
                      htmlFor="substate"
                      className="w-24 text-right mr-4 text-sm text-gray-700"
                    >
                      Sub State
                    </label>

                    <div className="flex-1">
                      <select
                        id="substate"
                        className="w-full border-2 border-gray-300 rounded px-2 text-sm h-9 bg-white focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition"
                        value={selectedSubState}
                        onChange={(e) => handleSubStateChange(e.target.value)}
                        disabled={!selectedState || isLoading}
                      >
                        <option value="">All</option>
                        {substates.map((sub) => (
                          <option key={sub.id} value={sub.id}>
                            {sub.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Year row */}
                  <div className="flex items-center">
                    <label
                      htmlFor="year"
                      className="w-24 text-right mr-4 text-sm text-gray-700"
                    >
                      Year
                    </label>

                    <div className="flex-1">
                      <select
                        id="year"
                        className="w-full border-2 border-gray-300 rounded px-2 text-sm h-9 bg-white focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition"
                        value={selectedYear}
                        onChange={(e) => {
                          setSelectedYear(e.target.value);
                          setShowContainers(false);
                        }}
                        disabled={isLoading}
                      >
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* MIDDLE spacer: col-span 2 */}
                <div className="md:col-span-2 col-span-12 flex justify-center" />

                {/* RIGHT: col-span 5 */}
                <div className="md:col-span-5 col-span-12 space-y-3">
                  {/* Division row */}
                  <div className="flex items-center md:justify-start justify-center">
                    <label
                      htmlFor="division"
                      className="w-24 text-right mr-4 text-sm text-gray-700"
                    >
                      Division
                    </label>

                    <div className="flex-1">
                      <select
                        id="division"
                        className="w-full border-2 border-gray-300 rounded px-2 text-sm h-9 bg-white focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition"
                        value={selectedDivision}
                        onChange={(e) => handleDivisionChange(e.target.value)}
                        disabled={!selectedState || isLoading}
                      >
                        <option value="">All</option>
                        {divisions.map((division) => (
                          <option key={division.id} value={division.id}>
                            {division.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Month row */}
                  <div className="flex items-center md:justify-start justify-center">
                    <label
                      htmlFor="month"
                      className="w-24 text-right mr-4 text-sm text-gray-700"
                    >
                      Month
                    </label>

                    <div className="flex-1">
                      <select
                        id="month"
                        className="w-full border-2 border-gray-300 rounded px-2 text-sm h-9 bg-white focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition"
                        value={selectedMonth}
                        onChange={(e) => {
                          setSelectedMonth(e.target.value);
                          setShowContainers(false);
                        }}
                        disabled={isLoading}
                      >
                        {months.map((month) => (
                          <option key={month} value={month}>
                            {month}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="h-6" />
                </div>

                {/* button row centered */}
                <div className="md:col-span-12 col-span-12 mt-2 flex justify-center">
                  <CustomButton
                    onClick={handleGoClick}
                    variant="go"
                    disabled={isLoading}
                    isLoading={isLoading}
                  >
                    GO
                  </CustomButton>
                </div>
              </div>
            </form>
          </div>
        </section>

        {/* Results Section */}
        {showContainers && (
          <div className="mt-6">
            <div className="flex justify-between items-center">
              <div className="w-32">
                <img
                  src={logo}
                  alt="Company Logo"
                  className="h-12 object-contain"
                />
              </div>
              <h2 className="text-lg font-bold text-center">
                Employee Expense Sheets ({employeesData.length})
              </h2>
              <div className="w-32"></div>
            </div>

            {/* Employee Sheets */}
            {employeesData.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                No employee expense records found. Please try different filters.
              </div>
            ) : (
              <div className="space-y-8">
                {employeesData.map((employee, index) => (
                  <div
                    key={employee.header?.employee || index}
                    className="page-break"
                  >
                    <DynamicExpenseTable
                      data={employee}
                      onDateClick={openMapModal}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Action Buttons */}
        {employeesData.length > 0 && (
          <div className="mt-4 flex gap-4 justify-center">
            <CustomButton
              onClick={printAllSheets}
              label="Print"
              variant="print"
            >
              🖨
            </CustomButton>
            <CustomButton
              onClick={exportAllToExcel}
              label="Export"
              variant="export"
            >
              📥
            </CustomButton>
          </div>
        )}
      </div>

      {/* ✅ Dynamic Map Modal */}
      {mapModal.isOpen && mapModal.employeeData && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-2">
          <div className="bg-white rounded-lg w-full max-w-7xl h-[95vh] flex flex-col">
            <div className="flex justify-between items-center p-4 border-b bg-white sticky top-0 z-10">
              <h3 className="text-xl font-bold text-gray-800">
                Employee Location Tracker - {mapModal.employeeData.employeeName}
              </h3>
              <button
                onClick={closeMapModal}
                className="text-gray-500 hover:text-gray-700 text-3xl font-bold bg-gray-100 hover:bg-gray-200 w-10 h-10 rounded-full flex items-center justify-center"
              >
                ×
              </button>
            </div>

            <div className="flex-1 p-1 overflow-hidden">
              <EmployeeMapTracker
                key={`${mapModal.employeeData.employeeId}-${mapModal.employeeData.trackDate}`}
                employeeId={mapModal.employeeData.employeeId}
                trackDate={mapModal.employeeData.trackDate}
                employeeName={mapModal.employeeData.employeeName}
                context={mapModal.employeeData.context}
                location={mapModal.employeeData.location}
                onClose={closeMapModal}
                isModal={true}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpensePrint;
